let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hGLdi")).then(() => parcelRequire('d7PIu'));